var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodeoAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5474 13.4449C25.9161 11.7968 25.3334 11.0196 23.9557 10.6111C21.4872 9.87912 20.2435 10.709 18.5116 10.6274C16.7798 10.5458 15.4199 9.45179 14.4997 8.74088C13.5796 8.02996 11.8168 7.79434 10.8489 9.31275C9.9008 10.813 8.08042 13.0161 8.87358 15.2087C9.6486 17.3815 11.3835 18.207 12.3262 20.464C13.269 22.7209 13.229 24.7549 14.5971 25.782C16.0316 26.8591 19.2559 27.5737 21.3584 25.9319C23.0495 24.6113 23.0102 22.2339 24.5482 20.7614C26.0862 19.2889 27.0276 18.6216 27.2553 17.5722C27.4827 16.5247 27.0633 14.7915 26.5474 13.4449Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodeoAppIcon);
export default __webpack_public_path__ + "static/media/rodeo-app-icon.965a3c0697308bf795e0fe842bbdfd60.svg";
export { ForwardRef as ReactComponent };